<template>
  <li class="nav-item active">
    <router-link class="nav-link" :to="to">
      <!--sidenav-mini-icon-->
      <i class="material-symbols-outlined text-white" > {{ miniIcon }} </i>
      <span class="sidenav-normal me-3 ms-3 ps-1 text-white text-white">
        {{ text }}
      </span>
    </router-link>
  </li>
</template>
<script>
export default {
  name: "SidenavItem",
  props: {
    to: {
      type: [Object, String],
      required: true
    },
    miniIcon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>
